import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { DownloadJobService } from '../services/download-job.service';

/**
 * Shows where the signed-in user's background ZIP download is, in a toolbar: how far the server has got, or why it
 * failed. A finished ZIP is saved automatically, so nothing is shown for it beyond a moment's "ready".
 */
@Component({
    selector: 'xp-download-status',
    standalone: true,
    imports: [CommonModule, MatButtonModule, MatProgressBarModule],
    template: `
        <div *ngIf="downloads.job$ | async as job" class="download-status" [class.failed]="job.status === 'Failed'">
            <ng-container [ngSwitch]="job.status">
                <ng-container *ngSwitchCase="'Failed'">
                    <span>{{ job.message || 'The download could not be prepared.' }}</span>
                    <button mat-button color="accent" (click)="downloads.dismiss()">Dismiss</button>
                </ng-container>
                <ng-container *ngSwitchCase="'Completed'">
                    <span>Your download is ready...</span>
                </ng-container>
                <ng-container *ngSwitchDefault>
                    <span>{{ job.total === 0 ? 'Preparing your download...' : 'Preparing your download: ' + job.processed + ' of ' + job.total }}</span>
                    <mat-progress-bar class="download-progress"
                                      [mode]="job.total > 0 ? 'determinate' : 'indeterminate'"
                                      [value]="job.total > 0 ? (job.processed / job.total) * 100 : 0"></mat-progress-bar>
                </ng-container>
            </ng-container>
        </div>`,
    styles: [`
        .download-status { display: flex; align-items: center; gap: 12px; margin-right: 8px; }
        .download-status.failed { color: #d32f2f; }
        .download-progress { width: 160px; }
    `]
})
export class DownloadStatusComponent {
    constructor(public downloads: DownloadJobService) { }
}
